import { TCloudDevice } from '@reolink-cloud/interface';

/**
 * 获取设备的title
 * @description 优先级: onlineConfig > configTemplate > channel > model title > uid
 *  - onlineConfig 绑定设备就会有
 *  - configTemplate 绑定设备就会有
 *  - channel 设备上报
 *  - model title 设备上报
 *  - uid 本身就有
 */
export const handleDeviceTitle = ( device: TCloudDevice ): string => {

    let onlineConfigTitle = '';

    const onlineConfig = device.onlineConfig?.config?.configure as Array<Record<string, any>> | undefined;

    if ( onlineConfig ) {

        if ( onlineConfig.length > 1 ) {

            const deviceChannel = onlineConfig.find( _config => _config.channelId === -1 );
            if ( deviceChannel ) {

                onlineConfigTitle = deviceChannel.getSystemGeneralCfg.value?.device.name;

            }

        } else if ( onlineConfig.length === 1 ) {

            onlineConfigTitle = onlineConfig[0].getSystemGeneralCfg.value?.device.name;

        }

    }

    if ( onlineConfigTitle ) {

        return onlineConfigTitle;

    }

    let configTemplateTitle = '';

    const configTemplate = device.configTemplate?.configure as Array<Record<string, any>> | undefined;

    if ( configTemplate ) {

        if ( configTemplate.length > 1 ) {

            const deviceChannel = configTemplate.find( _config => _config.channelId === -1 );
            if ( deviceChannel ) {

                configTemplateTitle = deviceChannel.getSystemGeneralCfg?.initial?.value?.device?.name;

            }

        } else if ( configTemplate.length === 1 ) {

            configTemplateTitle = configTemplate[0].getSystemGeneralCfg?.initial?.value?.device?.name;

        }

    }

    if ( configTemplateTitle ) {

        return configTemplateTitle;

    }

    let defaultTitle = '';

    const channels = device.channels ?? [];

    const deviceModelTitle = device.model?.title;

    if ( channels.length > 1 ) {

        defaultTitle = channels.find( channel => channel.channelId === -1 )?.title ?? '';

    } else if ( channels.length === 1 ) {

        defaultTitle = channels.find( channel => channel.channelId === 0 )?.title ?? '';

    }

    if ( !defaultTitle ) {

        defaultTitle = deviceModelTitle ?? device.uid;

    }

    return defaultTitle;

};
